import React from 'react';

/**
 * Root error boundary. Catches JavaScript errors in the child tree,
 * logs them, and displays a fallback UI instead of crashing.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        try {
            const { reportFaroError } = require('../observability');
            if (error instanceof Error) {
                reportFaroError(error, { componentStack: errorInfo?.componentStack?.slice(0, 200) });
            }
        } catch (_) {
            // observability not available or not enabled
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        padding: '2rem',
                        textAlign: 'center',
                        fontFamily: 'sans-serif',
                        minHeight: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxSizing: 'border-box',
                    }}
                >
                    <h1 style={{ marginBottom: '1rem', color: '#333' }}>Something went wrong</h1>
                    <p style={{ color: '#666', maxWidth: '480px' }}>
                        We're sorry. An unexpected error occurred. Please refresh the page or try again later.
                    </p>
                    {this.state.error && (
                        <details style={{ marginTop: '1rem', textAlign: 'left', color: '#888', fontSize: '0.875rem' }}>
                            <summary>Error details</summary>
                            <pre style={{ overflow: 'auto', marginTop: '0.5rem' }}>
                                {this.state.error.toString()}
                            </pre>
                        </details>
                    )}
                    <button
                        type="button"
                        onClick={() => window.location.reload()}
                        style={{
                            marginTop: '1.5rem',
                            padding: '0.5rem 1rem',
                            fontSize: '1rem',
                            cursor: 'pointer',
                        }}
                    >
                        Refresh page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
